import { SettingsResponse } from '@business/entities/settings';
import { Endpoint } from '../endpoint';
import { memoize } from '@core/utils/rxjs/operators';

export function fetchSettings(fromMemoize = false) {
  return Endpoint.get<SettingsResponse>(`@makh/settings`).pipe(
    memoize({
      key: 'fetchSettings',
      options: { timeout: 60, refresh: !fromMemoize },
    }),
  );
}

export function updateInstructorsSettings(data: Partial<SettingsResponse>) {
  return Endpoint.post<SettingsResponse>(`@makh/settings/instructors`, { data });
}
